import { PipeTransform, Pipe } from "@angular/core";

@Pipe({
    name: "DateTimeFormat"
})
export class DateTimeFormatPipe implements PipeTransform {
    // value format should be yyyy-MM-ddThh:mm:ss
    // return result will be yyyy-MM-dd hh:mm:ss
    transform(value: string) {
        if (value != null && value != "") {
            let dateTime: string[] = value.split('T');

            return dateTime[0] + " " + dateTime[1];
        }
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/pipes/date-time-format.pipe.ts